import { StoreStatus } from '~/services/api/interfaces/Store'
import { normalizeStoreStatus } from './normalizeStoreStatus'

export const isStoreOnboardingEditable = (status: unknown): boolean => {
  const normalized = normalizeStoreStatus(status)
  return (
    normalized === StoreStatus.Draft ||
    normalized === StoreStatus.InReview ||
    normalized === StoreStatus.UpdatesRequired ||
    normalized === StoreStatus.Disabled
  )
}
